export default {
  ppwr: {
    steps: {
      files: {
        label: "Files",
        description: "Upload brand logo, package photo and declaration of conformity.",
      },
      traceability: {
        label: "Product traceability",
        description: "Review the selected product information used for this digital label.",
      },
      manufacturer: {
        label: "Manufacturer & representative",
        description: "Confirm brand owner details and Authorized Representative.",
      },
      packagingComposition: {
        label: "Packaging composition",
        description: "Add and describe all components that make up this packaging.",
      },
      preview: {
        label: "PPWR Label & Digital Link",
        description: "Review your completed label, print it, or copy the digital link.",
      },
    },
    v2Steps: {
      files: {
        label: "Files",
        description: "Upload supporting files.",
      },
      traceability: {
        label: "Product traceability",
        description: "Product and packaging details.",
      },
      manufacturer: {
        label: "Manufacturer & other parties",
        description: "Manufacturer and other parties.",
      },
      manufacturerIntro: "Provide the manufacturer / brand owner details and, where applicable, add an importer or authorised representative.",
      packagingComposition: {
        label: "Packaging composition",
        description: "Composition and recycling.",
      },
      preview: {
        label: "PPWR Label & Digital Link",
        description: "Preview and download your label.",
      },
    },
    weight: {
      missingTotal: "Provide total packaging weight on Product traceability",
      withinTolerance: "Within tolerance",
      below: "Below total packaging weight",
      above: "Above total packaging weight",
    },
    preview: {
      defaultFileName: "Packaging label.pdf",
      loadFailed: "Could not load the label PDF.",
      displayFailed: "The label preview could not be displayed. You can still download the label.",
      loading: "Loading label preview…",
      fullPageAria: "Preview of the full page of the generated packaging label {{name}}",
      aria: "Preview of the generated packaging label {{name}}",
      notAvailable: "The label PDF is not available.",
      empty: "The label PDF is empty.",
      displayFailedShort: "The label preview could not be displayed.",
    },
    summary: {
      title: "Summary",
      totalWeight: "Total packaging weight",
      element: "Element",
    },
    actions: {
      downloading: "Downloading…",
      downloadQr: "Download QR",
      copied: "Copied",
      copyDigitalLink: "Copy digital link",
      downloadLabel: "Download label",
    },
    recycling: {
      sortingCodesAria: "Sorting codes",
      sortingCode: "Sorting code",
      sortingInstructions: "Sorting instructions",
      customSortingInstructions: "Custom sorting instructions",
      add: "Add recycling info",
      emptyTitle: "No recycling information added yet",
      emptyHint: "Add a sorting code or sorting instructions when you are ready.",
      chooseTypeTitle: "Choose information type",
      chooseTypeDescription: "Select the type of recycling information to add.",
      removeBody: "This recycling information will be removed from the packaging label. You can add it again later if needed.",
      defaultTitle: "Recycling info",
      editTitle: "Edit {{type}}",
      addTitle: "Add {{type}}",
      removeTitle: {
        sorting_code: "Remove sorting code?",
        sorting_instructions: "Remove sorting instructions?",
        default: "Remove recycling info?",
      },
      errors: {
        required: "Complete the required fields.",
        selectCode: "Select at least one sorting code.",
        selectInstruction: "Select a sorting instruction.",
        customInstruction: "Enter custom sorting instructions.",
        invalidType: "Invalid entry type.",
      },
    },
    common: {
      other: "Other",
      mandatory: "Mandatory",
      optional: "Optional",
    },
    wizard: {
      createTitle: "Create Packaging Label (PPWR)",
      errors: {
        loadPackaging: "Could not load packaging record.",
        checkLabel: "Could not check whether this packaging already has a label.",
        loadLabel: "Could not load the packaging label.",
        batchSelectSku: "Could not generate a batch / lot number. Select a packaging SKU first.",
        batchManual: "Could not generate a batch / lot number. Enter one manually.",
        saveTraceabilityFirst: "Save product traceability first to create a packaging label.",
        saveDetails: "Could not save label details before generating.",
        saveManufacturer: "Could not save manufacturer details before generating.",
        reloadLabel: "Could not reload the packaging label.",
        generate: "Could not generate the packaging label.",
        completeRequired: "Complete required fields before generating the label.",
        generatedNotReloaded: "Label was generated but could not be reloaded.",
        generatedNoPdf: "Label was generated but the PDF is not available yet.",
        generatedNoQr: "Label was generated but QR data is not available yet.",
        downloadQr: "Could not download the QR code.",
        downloadLabel: "Could not download the label PDF.",
        packagingNameRequired: "Packaging name is required before publishing.",
        manufacturerRequired: "Manufacturer company name is required before publishing.",
      },
      generateLabel: "Generate label",
      generating: "Generating…",
      saving: "Saving…",
      subtitle: "Add brand assets and packaging compliance details for this digital label.",
      backLabel: "Products",
      recyclingSavedNoPdf: "Recycling information was saved, but the label PDF could not be regenerated. Click Generate label to rebuild it.",
      stepsAria: "Digital label wizard steps",
      leaveTitle: "Leave this digital label?",
      leaveBody: "You have unsaved changes. Leaving will discard changes that have not been saved with Next.",
      labelPdfUnavailable: "Label PDF not available yet.",
      publishedLabelPdfUnavailable: "The label PDF is not available for this published label.",
      savedNoPdf: "Your changes were saved, but the label PDF is not available right now. Your digital link and QR code were not changed.",
      batchUnavailable: "Available once the packaging is Active. Enter a batch / lot number manually.",
      unsavedRecyclingBlocker: "Save or close the open recycling information before generating the label.",
    },
    files: {
      noneSelected: "Optional · No files selected",
      addedOne: "1 file added",
      addedMany: "{{count}} files added",
      errors: {
        pngSvg: "Upload a PNG or SVG file.",
        jpgPng: "Upload a JPG or PNG file.",
        max50: "Maximum file size is 50 MB.",
      },
      removePhoto: "Remove package photo?",
      intro: "Upload optional brand and packaging assets for this digital label.",
      savedHint: "Files will be saved when you save the label.",
      logoHelper: "PNG or SVG. Max size 5 MB.",
      packagePhoto: "Package photo",
      photoHelper: "JPG or PNG. Use a well-lit package photo.",
      removeBody: "The file will be removed from this digital label. You can upload a new one at any time.",
      removeFile: "Remove file?",
      skipStep: "Skip this step",
    },
    final: {
      v2Intro: "Review the generated packaging label PDF. Download the label or QR code and copy the digital link from the actions below.",
      notGenerated: "Packaging label has not been generated yet.",
      notGeneratedHint: "Complete the previous steps and generate the label to preview it here.",
    },
    composition: {
      mandatoryBy: "Mandatory by August 2028",
      v2Intro: "Review packaging elements from the source record and add recycling information for the digital label.",
      weightHint: "Provide total packaging weight on Product traceability to calculate component percentages and verify packaging weight.",
      percentOfTotal: "% of total",
      consumerSeparable: "Consumer separable",
      empty: "No packaging components yet",
      totals: "Totals",
    },
    parties: {
      chooseTypeDescription: "Select the party you want to add to this digital label.",
    },
    traceability: {
      batchLot: "Batch / Lot",
      batchPlaceholder: "Batch / lot number",
      generateBatch: "Generate batch number",
      targetMarket: "Target Market",
      selectTargetMarket: "Select target market",
      generateBatchReason: "Generate batch number. {{reason}}",
      product: "Product",
      productName: "Product name",
      batchLotNumber: "Batch / Lot Number",
      size: "Size",
      grossWeight: "Gross Weight",
      grossWeightPlaceholder: "Gross weight",
      grossWeightUnit: "Gross weight unit",
      totalWeightUnit: "Total packaging weight unit",
    },
    legacy: {
      editTitle: "Edit Packaging Label (PPWR)",
      errors: {
        loadComponents: "Could not load the packaging label components.",
        loadCountries: "Could not load the packaging label countries.",
        qr: "Could not generate the label QR code.",
      },
      generatingLabel: "Generating label...",
      finish: "Finish",
      stepsAria: "Wizard steps",
      saving: "Saving...",
      leaveTitle: "Leave digital label setup?",
      leaveBody: "Changes saved on previous steps will remain available. Unsaved changes on this step will be lost. You can continue setup later from the Products page.",
      leaveSetup: "Leave setup",
      stay: "Stay",
      deleteComponentTitle: "Delete packaging component?",
      deleteComponentBody: "This packaging component will be permanently deleted. This action cannot be undone.",
      deleteComponent: "Delete component",
      pdfUnavailable: "PDF download is not available yet.",
      downloadLabelAria: "Download label. {{reason}}",
      deleteComponentNamed: "\"{{name}}\" will be permanently deleted. This action cannot be undone.",
    },
    component: {
      creation: "Component creation",
      manual: "Manual",
      aiAssisted: "AI Assisted",
      aiSuggestion: "AI suggestion",
      aiHelper: "Preview of future AI-assisted packaging component suggestions based on uploaded product documentation.",
      selectSuggestion: "Select suggestion",
      componentType: "Component type",
      selectComponentType: "Select component type",
      customComponentType: "Custom component type",
      enterComponentType: "Enter component type",
      materialFamily: "Material family",
      selectMaterialFamily: "Select material family",
      customMaterialFamily: "Custom material family",
      enterMaterialFamily: "Enter material family",
      materialSubtype: "Material subtype",
      selectMaterialSubtype: "Select material subtype",
      rigidOrFlexible: "Rigid or flexible?",
      pcrContent: "Post-consumer recycled content (%)",
      bioBasedContent: "Bio-based content (%)",
      biodegradable: "Is the plastic biodegradable?",
      compostable: "Is it compostable?",
      percentage: "Percentage of total packaging weight",
      percentageHint: "Provide total packaging weight on Product traceability to calculate percentage.",
      separable: "Can the consumer separate this component?",
      recyclingCode: "Recycling Code",
      selectRecyclingCodes: "Select recycling codes",
      recyclingCodes: "Recycling codes",
      sortingInstruction: "Sorting Instruction",
      selectSortingInstruction: "Select sorting instruction",
      reusable: "Reusable or refillable",
      recycledDescription: "Recycled content description",
      recycledDescriptionPlaceholder: "Describe recycled content",
      recyclingStream: "Intended recycling stream",
      selectRecyclingStream: "Select recycling stream",
      notes: "Additional notes",
      editTitle: "Edit packaging component",
      addTitle: "Add packaging component",
    },
    qr: {
      downloadFailed: "Could not download the QR code image.",
      missing: "This label has no QR code yet.",
    },
    manufacturer: {
      businessName: "Manufacturer business name",
      intro: "Confirm the brand owner and other parties for this packaging label. Add or edit the authorised representative here when required.",
      manufacturerTitle: "Manufacturer (Brand owner)",
      representativeTitle: "Authorized Representative",
      addRepresentativeHint: "Add an authorised representative for this packaging label when required.",
      addRepresentative: "Add representative",
      importerInfo: "You do not need to list separate importer information if the company importing the goods into the European Union is legally considered the ‘Manufacturer’ under the Packaging and Packaging Waste Regulation (PPWR).",
      importerHint: "Add importer details for this packaging label.",
      importerDisabledHint: "Leave disabled if separate importer information is not required.",
      disableImporterTitle: "Disable importer?",
      disable: "Disable",
    },
  },
};
